import './Logo.css'

function Logo() {
  return (
    <img
      src="/assets/logo.png"
      alt="Laboratory Specialists Logo"
      className="logo-icon"
    />
  )
}

export default Logo
